export default __webpack_public_path__ + "static/media/162.dd05be48.png";